import React from 'react';
import cn from 'classnames';
import PT from 'prop-types';

const Radio = ({ options, fieldProps: { onChange, value }, helperVariant }) => {
  const handleSelect = (option) => () => onChange(option);

  return (
    <div className={cn('radio-field', { 'radio-field_error': helperVariant === 'error' })}>
      {options.map((option) => (
        <button
          type="button"
          key={option.id}
          className={cn({ active: value?.id == option.id })}
          onClick={handleSelect(option)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

Radio.propTypes = {
  options: PT.arrayOf(PT.object),
  fieldProps: PT.object,
};

export default Radio;
